import React from 'react';
import './index.less'
export default class Footer extends React.Component {


    render() {
        return (
            <div className='footer'>
                @CopyRight 2019-2020 long time ago, there is a hero.
                <a className='beian' href='http://beian.miit.gov.cn' target='_blank'>备案号：苏ICP备20014562号</a>
            </div>
        );
    }
}